// extracted by mini-css-extract-plugin
module.exports = {"antTable":"Table_antTable__rFuIi","darkRowTable":"Table_darkRowTable__2z_8V","lightRowTable":"Table_lightRowTable__3d6TW"};